import { ethers } from 'ethers'
import config from '@/config'
import { showToast, showLoadingToast, closeToast } from 'vant'
// abiMap["single"] = '[{"internalType": "address", "name": "contractAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]';
// abiMap["double"] = '[{"internalType": "address", "name": "contractAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "address", "name": "contractAddress1", "type": "address"},{"internalType": "uint256", "name": "amount1", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]';
let provider = null
let signer = null

const isWalletInstalled = () => {
  return typeof window !== 'undefined' && !!window.ethereum
}

export const ensureReady = async (isSwitchChain = false) => {
  if (!isWalletInstalled()) {
    showToast('请安装钱包（如 MetaMask）')
    throw new Error('Wallet not installed')
  }
  // if (window.ethereum.chainId !== config.network.chainId) {
  // 	showNotify({ type: 'warning', message: '请切换到主网络' })
  // 	if (!isSwitchChain){
  // 		setTimeout(() => {
  // 			switchChain()
  // 		}, 200)
  // 	}
  // 	throw new Error('Chain not supported')
  // }
  if (!provider) {
    provider = new ethers.BrowserProvider(window.ethereum)
  }
  if (!signer) {
    signer = await provider.getSigner()
  }
  return { provider, signer }
}

// 原生转账（使用 MetaMask）
export const transfer = async (amount, address) => {
  await ensureReady()
  const amountWei = ethers.parseUnits(amount.toString(), 18)
  return await signer.sendTransaction({ to: address, value: amountWei, gasLimit: 2000000 })
}

// BNB转账（兑换专用）
export const transferBNB = async (amount, address) => {
  await ensureReady()
  const amountWei = ethers.parseUnits(amount.toString(), 18)

  try {
    showLoadingToast({
      message: '确认BNB转账中...',
      duration: 0
    })

    const tx = await signer.sendTransaction({
      to: address,
      value: amountWei,
      gasLimit: 21000 // BNB转账的标准gas limit
    })

    if (tx.hash) {
      showLoadingToast({
        message: 'BNB转账中...',
        duration: 0
      })
    }

    closeToast()
    showToast('BNB转账成功')
    return tx
  } catch (error) {
    closeToast()
    showToast('BNB转账失败')
    throw error
  }
}

//切换网络
export const switchChain = async () => {
  try {
    window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: config.network.chainId }]
    })
  } catch (error) {
    if (error.code === 4902) {
      window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: config.network
      })
    }
  }
}

// 初始化主合约
const getMainContract = async () => {
  const { signer } = await ensureReady()
  return new ethers.Contract(config.main.address, config.main.abi, signer)
}
// 初始化自定义合约
const getCustomContract = async () => {
  const { signer } = await ensureReady()
  return new ethers.Contract(config.custom.address, config.custom.abi, signer)
}

// 调用签名
export const signMessage = async (message) => {
  await ensureReady()
  return await signer.signMessage(message)
}

// 主合约授权额度
export const getMainAllowance = async () => {
  await ensureReady()
  const mainContract = await getMainContract()
  return await mainContract.allowance(signer.address, config.custom.address)
}

// 查询主网代币余额
export const getMainBalance = async () => {
  await ensureReady()
  const address = signer.address
  const mainContract = await getMainContract()
  //业务层 需要使用ethers.formatUnits(balance, 18) 格式化 这里直接返回wei
  return await mainContract.balanceOf(address)
}

// 查询指定 ERC20 代币余额（通用方法）
export const getTokenBalance = async (contractAddress) => {
  await ensureReady()
  const address = signer.address
  console.log('[web3.getTokenBalance] start', {
    contractAddress,
    account: address
  })

  // 验证合约地址格式
  if (!contractAddress || !ethers.isAddress(contractAddress)) {
    console.error('Invalid contract address:', contractAddress)
    return '0'
  }

  // ERC20 标准 ABI，只需要 balanceOf 方法
  const erc20Abi = [
    'function balanceOf(address owner) view returns (uint256)',
    'function decimals() view returns (uint8)'
  ]

  try {
    // 获取当前网络信息
    console.log('[web3.getTokenBalance] before getNetwork', {
      contractAddress,
      account: address
    })
    const network = await signer.provider.getNetwork()
    console.log('当前连接的网络:', {
      chainId: network.chainId,
      name: network.name
    })
    console.log('配置的目标网络链ID:', config.network.chainId)

    const tokenContract = new ethers.Contract(contractAddress, erc20Abi, signer)

    // 调用 balanceOf 方法
    console.log('[web3.getTokenBalance] before balanceOf', {
      contractAddress,
      account: address
    })
    const balance = await tokenContract.balanceOf(address)
    console.log('[web3.getTokenBalance] success', {
      contractAddress,
      account: address,
      rawBalance: balance?.toString?.() || balance
    })
    return balance
  } catch (error) {
    console.error('获取代币余额失败:', error)
    console.error('合约地址:', contractAddress)
    console.error('用户地址:', address)

    // 返回0而不是抛出错误，避免阻断用户操作
    return '0'
  }
}

// 获取指定代币的授权额度
export const getTokenAllowance = async (tokenAddress, spenderAddress) => {
  await ensureReady()
  const erc20Abi = ['function allowance(address owner, address spender) view returns (uint256)']
  const tokenContract = new ethers.Contract(tokenAddress, erc20Abi, signer)
  return await tokenContract.allowance(signer.address, spenderAddress)
}

// 授权指定代币
export const approveToken = async (tokenAddress, spenderAddress, amount = null) => {
  await ensureReady()
  const erc20Abi = ['function approve(address spender, uint256 amount) returns (bool)']
  const tokenContract = new ethers.Contract(tokenAddress, erc20Abi, signer)

  // 如果指定了具体数量，就授权该数量；否则授权最大值
  const approveAmount = amount || ethers.MaxUint256

  try {
    // 手动设置 gas limit 避免 gas 估算失败
    const tx = await tokenContract.approve(spenderAddress, approveAmount, {
      gasLimit: 100000 // ERC20 授权通常只需要 46000 左右，设置 100000 足够了
    })
    return tx
  } catch (error) {
    console.error('授权失败详情:', error)

    // 如果是 gas 估算失败，尝试用更高的 gas limit
    if (error.message.includes('gas') || error.code === 'UNKNOWN_ERROR') {
      console.log('尝试使用更高的 gas limit 重新授权...')
      try {
        const tx = await tokenContract.approve(spenderAddress, approveAmount, {
          gasLimit: 200000
        })
        return tx
      } catch (retryError) {
        console.error('重试授权失败:', retryError)
        throw retryError
      }
    }
    throw error
  }
}

// 支付
export const pay = async (amount, remark) => {
  await ensureReady()
  const amountWei = ethers.parseUnits(amount.toString(), 18)
  //获取当前地址余额 暂时不验证余额 放到业务层
  // const currentBalance = await getMainBalance(signer.address)
  // if (currentBalance < amountWei) {
  // 	showNotify('余额不足')
  // 	return
  // }
  const allowance = await getMainAllowance()
  if (allowance < amountWei) {
    showLoadingToast({
      message: '确认授权中...',
      duration: 0
    })
    let tx = await approve()
    if (tx.hash) {
      showLoadingToast({
        message: '确认授权中...',
        duration: 0
      })
    }
    await tx.wait()
    showLoadingToast({
      message: '授权成功...',
      duration: 0
    })
  }
  try {
    showLoadingToast({
      message: '确认支付中...',
      duration: 0
    })
    const abiKey = 'single'
    const to = config.main.address
    const abiCoder = ethers.AbiCoder.defaultAbiCoder()
    const data = abiCoder.encode(['address', 'uint256', 'string'], [to, amountWei, remark])
    const customContract = await getCustomContract()
    try {
      const tx = await customContract.recharge(abiKey, data, { gasLimit: 1000000 })
      if (tx.hash) {
        showLoadingToast({
          message: '链上确认中...',
          duration: 0
        })
      }
      await tx.wait()
      closeToast()
      showToast('支付成功')
      Promise.resolve(tx)
    } catch (error) {
      showToast('支付失败')
    }
  } catch (error) {
    showToast('支付失败')
  }
}

// 主合约授权
export const approve = async () => {
  await ensureReady()
  const mainContract = await getMainContract()
  return await mainContract.approve(config.custom.address, ethers.MaxUint256)
}

// 挖矿支付通用方法
/**
 * @param {Object} params - 支付参数
 * @param {string} params.abiKey - ABI key (mining, miningActive, lp 或 merge)
 * @param {string} params.tokenAddress - 代币合约地址 (mining/miningActive/merge用，lp时是第一个代币地址)
 * @param {string} params.tokenAddress2 - 第二个代币合约地址 (仅lp需要)
 * @param {number} params.decimals - 代币精度
 * @param {string} params.amount - 支付数量
 * @param {string} params.remark - 订单号
 * @param {Object} params.addresses - 地址配置 (mining需要studioAddress/lecturerAddress/leaderAddress/zeroAddress, miningActive和merge不需要, lp需要amount1和amount2)
 */
export const miningPay = async ({
  abiKey,
  tokenAddress,
  tokenAddress2,
  decimals,
  amount,
  remark,
  addresses = {}
}) => {
  await ensureReady()
  const amountWei = ethers.parseUnits(amount.toString(), decimals || 18)

  // LP支付详细日志
  if (abiKey === 'lp') {
    console.log('==================== LP支付参数详情 ====================')
    console.log('1. 接收到的原始参数:')
    console.log('   - abiKey:', abiKey)
    console.log('   - tokenAddress (第一个代币-USDT):', tokenAddress)
    console.log('   - tokenAddress2 (第二个代币-LON):', tokenAddress2)
    console.log('   - decimals:', decimals)
    console.log('   - amount (主要金额):', amount)
    console.log('   - remark (订单号):', remark)
    console.log('2. addresses对象:')
    console.log('   - amount1 (LON数量,纯U时为0):', addresses.amount1?.toString())
    console.log('   - amount2 (USDT数量):', addresses.amount2?.toString())
    console.log('3. 格式化后的金额:')
    console.log(
      '   - amount1 (LON) 格式化:',
      addresses.amount1 ? ethers.formatUnits(addresses.amount1, 18) : '0'
    )
    console.log('   - amount2 (USDT) 格式化:', ethers.formatUnits(addresses.amount2, 18))
    console.log('====================================================')
  }

  // 获取挖矿合约配置
  const miningContract = config.mining
  if (!miningContract) {
    throw new Error('Mining contract not configured')
  }

  try {
    // 1. 检查代币余额
    showLoadingToast({
      message: '检查余额...',
      duration: 0
    })

    if (abiKey === 'lp') {
      // LP 需要检查两个代币的余额
      const { amount1, amount2 } = addresses

      console.log('==================== LP余额检查 ====================')
      console.log('检查第一个代币 (USDT):')
      console.log('   - 代币地址:', tokenAddress)
      console.log('   - 需要数量:', ethers.formatUnits(amount2, 18))

      // 检查第一个代币余额
      const balance1 = await getTokenBalance(tokenAddress)
      console.log('   - 链上余额:', ethers.formatUnits(balance1, 18))
      console.log('   - 余额是否充足:', balance1 >= amount2)

      if (balance1 < amount2) {
        closeToast()
        showToast('USDT链上余额不足')
        console.log('❌ USDT余额不足！')
        console.log('====================================================')
        throw new Error('Insufficient balance for USDT')
      }
      console.log('✅ USDT余额充足')

      // 检查第二个代币余额
      if (tokenAddress2 && amount1 > 0n) {
        console.log('检查第二个代币 (LON):')
        console.log('   - 代币地址:', tokenAddress2)
        console.log('   - 需要数量:', ethers.formatUnits(amount1, 18))

        const balance2 = await getTokenBalance(tokenAddress2)
        console.log('   - 链上余额:', ethers.formatUnits(balance2, 18))
        console.log('   - 余额是否充足:', balance2 >= amount1)

        if (balance2 < amount1) {
          closeToast()
          showToast('LON链上余额不足')
          console.log('❌ LON余额不足！')
          console.log('====================================================')
          throw new Error('链上余额不足')
        }
        console.log('✅ LON余额充足')
      } else {
        console.log('纯U模式，无需检查LON余额')
      }
      console.log('====================================================')
    } else {
      // mining、miningActive 和 merge 只需要检查一个代币余额
      const balance = await getTokenBalance(tokenAddress)
      if (balance < amountWei) {
        closeToast()
        showToast('链上余额不足')
        throw new Error('链上余额不足')
      }
    }

    // 2. 检查授权
    if (abiKey === 'lp') {
      // LP 需要检查两个代币的授权
      const { amount1, amount2 } = addresses

      console.log('==================== LP授权检查 ====================')
      console.log('检查第一个代币 (USDT) 授权:')
      console.log('   - 代币地址:', tokenAddress)
      console.log('   - 合约地址:', miningContract.address)
      console.log('   - 需要授权:', ethers.formatUnits(amount2, 18))

      // 检查第一个代币授权
      const allowance1 = await getTokenAllowance(tokenAddress, miningContract.address)
      console.log('   - 当前授权:', ethers.formatUnits(allowance1, 18))
      console.log('   - 是否需要授权:', allowance1 < amount2)

      if (allowance1 < amount2) {
        showLoadingToast({
          message: '授权USDT...',
          duration: 0
        })
        console.log('开始USDT授权...')
        let approveTx = await approveToken(tokenAddress, miningContract.address)
        if (approveTx.hash) {
          console.log('USDT授权交易已发送:', approveTx.hash)
          showLoadingToast({
            message: '确认授权中...',
            duration: 0
          })
        }
        await approveTx.wait()
        console.log('✅ USDT授权成功')
      } else {
        console.log('✅ USDT授权充足，无需授权')
      }

      // 检查第二个代币授权
      if (tokenAddress2 && amount1 > 0n) {
        console.log('检查第二个代币 (LON) 授权:')
        console.log('   - 代币地址:', tokenAddress2)
        console.log('   - 合约地址:', miningContract.address)
        console.log('   - 需要授权:', ethers.formatUnits(amount1, 18))

        const allowance2 = await getTokenAllowance(tokenAddress2, miningContract.address)
        console.log('   - 当前授权:', ethers.formatUnits(allowance2, 18))
        console.log('   - 是否需要授权:', allowance2 < amount1)

        if (allowance2 < amount1) {
          showLoadingToast({
            message: '授权LON...',
            duration: 0
          })
          console.log('开始LON授权...')
          let approveTx2 = await approveToken(tokenAddress2, miningContract.address)
          if (approveTx2.hash) {
            console.log('LON授权交易已发送:', approveTx2.hash)
            showLoadingToast({
              message: '确认授权中...',
              duration: 0
            })
          }
          await approveTx2.wait()
          console.log('✅ LON授权成功')
        } else {
          console.log('✅ LON授权充足，无需授权')
        }
      } else {
        console.log('纯U模式，无需LON授权')
      }
      console.log('====================================================')

      showLoadingToast({
        message: '授权成功',
        duration: 0
      })
    } else {
      // mining、miningActive 和 merge 只需要检查一个代币授权
      const allowance = await getTokenAllowance(tokenAddress, miningContract.address)
      if (allowance < amountWei) {
        showLoadingToast({
          message: '授权中...',
          duration: 0
        })
        let approveTx = await approveToken(tokenAddress, miningContract.address)
        if (approveTx.hash) {
          showLoadingToast({
            message: '确认授权中...',
            duration: 0
          })
        }
        await approveTx.wait()
        showLoadingToast({
          message: '授权成功',
          duration: 0
        })
      }
    }
  } catch (error) {
    closeToast()
    console.error('余额/授权检查失败:', error)
    throw error
  }

  try {
    showLoadingToast({
      message: '确认支付中...',
      duration: 0
    })

    // 根据不同的 abiKey 编码不同的数据
    const abiCoder = ethers.AbiCoder.defaultAbiCoder()
    let encodedData

    if (abiKey === 'mining') {
      // mining 需要: contractAddress, studioAddress, lecturerAddress, leaderAddress, zeroAddress, amount, remark
      const { studioAddress, lecturerAddress, leaderAddress, autonomyAddress } = addresses
      encodedData = abiCoder.encode(
        ['address', 'address', 'address', 'address', 'address', 'uint256', 'string'],
        [
          tokenAddress,
          studioAddress,
          lecturerAddress,
          leaderAddress,
          autonomyAddress,
          amountWei,
          remark
        ]
      )
    } else if (abiKey === 'miningActive') {
      // miningActive 只需要: contractAddress, amount, remark
      encodedData = abiCoder.encode(
        ['address', 'uint256', 'string'],
        [tokenAddress, amountWei, remark]
      )
    } else if (abiKey === 'merge') {
      // merge 只需要: amount, remark
      encodedData = abiCoder.encode(['uint256', 'string'], [amountWei, remark])
    } else if (abiKey === 'lp') {
      // lp 需要: amount1, amount2, remark
      const { amount1 = amountWei, amount2 = amountWei } = addresses

      console.log('==================== LP ABI编码 ====================')
      console.log('编码参数:')
      console.log('   - amount1 (LON):', amount1.toString(), '=', ethers.formatUnits(amount1, 18))
      console.log('   - amount2 (USDT):', amount2.toString(), '=', ethers.formatUnits(amount2, 18))
      console.log('   - remark (订单号):', remark)
      console.log('编码顺序: [amount1, amount2, remark]')

      encodedData = abiCoder.encode(['uint256', 'uint256', 'string'], [amount1, amount2, remark])

      console.log('编码后的数据 (前100字符):', encodedData.substring(0, 100) + '...')
      console.log('====================================================')
    } else if (abiKey === 'super_consensus') {
      encodedData = abiCoder.encode(
        ['address', 'uint256', 'string'],
        [tokenAddress, amountWei, remark]
      )
    } else if (abiKey === 'game_node') {
      console.log('==================== game_node ABI编码 ====================')
      console.log('编码参数:')
      console.log(
        '   - amount:',
        amountWei.toString(),
        '=',
        ethers.formatUnits(amountWei, decimals || 18)
      )
      console.log('   - remark (订单号):', remark)
      console.log('编码顺序: [amount, remark]')

      encodedData = abiCoder.encode(['uint256', 'string'], [amountWei, remark])

      console.log('编码后的数据 (前100字符):', encodedData.substring(0, 100) + '...')
      console.log('====================================================')
    } else if (abiKey === 'game_pledge') {
      // game_pledge 需要: amount, remark

      console.log('==================== game_pledge ABI编码 ====================')
      console.log('编码参数:')
      console.log(
        '   - amount:',
        amountWei.toString(),
        '=',
        ethers.formatUnits(amountWei, decimals || 18)
      )
      console.log('   - remark (订单号):', remark)
      console.log('编码顺序: [amount, remark]')

      encodedData = abiCoder.encode(['uint256', 'string'], [amountWei, remark])

      console.log('编码后的数据 (前100字符):', encodedData.substring(0, 100) + '...')
      console.log('====================================================')
    } else if (abiKey === 'recharge') {
      // recharge 需要: tokenAddress, amount, remark

      console.log('==================== recharge ABI编码 ====================')
      console.log('编码参数:')
      console.log('   - tokenAddress:', tokenAddress)
      console.log(
        '   - amount:',
        amountWei.toString(),
        '=',
        ethers.formatUnits(amountWei, decimals || 18)
      )
      console.log('   - remark (订单号):', remark)
      console.log('编码顺序: [tokenAddress, amount, remark]')

      encodedData = abiCoder.encode(
        ['address', 'uint256', 'string'],
        [tokenAddress, amountWei, remark]
      )

      console.log('编码后的数据 (前100字符):', encodedData.substring(0, 100) + '...')
      console.log('====================================================')
    } else if (abiKey === 'peer_receive') {
      // peer_receive 需要: tokenAddress, amount, remark

      console.log('==================== peer_receive ABI编码 ====================')
      console.log('编码参数:')
      console.log('   - tokenAddress:', tokenAddress)
      console.log(
        '   - amount:',
        amountWei.toString(),
        '=',
        ethers.formatUnits(amountWei, decimals || 18)
      )
      console.log('   - remark (订单号):', remark)
      console.log('编码顺序: [tokenAddress, amount, remark]')

      encodedData = abiCoder.encode(
        ['address', 'uint256', 'string'],
        [tokenAddress, amountWei, remark]
      )

      console.log('编码后的数据 (前100字符):', encodedData.substring(0, 100) + '...')
      console.log('====================================================')
    } else if (abiKey === 'pgt_recharge') {
      // pgt_recharge 需要: studioAddress, amount, remark
      const { studioAddress } = addresses
      if (!studioAddress || !ethers.isAddress(studioAddress)) {
        throw new Error('Invalid studioAddress for pgt_recharge')
      }

      console.log('==================== pgt_recharge ABI编码 ====================')
      console.log('编码参数:')
      console.log('   - studioAddress:', studioAddress)
      console.log(
        '   - amount:',
        amountWei.toString(),
        '=',
        ethers.formatUnits(amountWei, decimals || 18)
      )
      console.log('   - remark (订单号):', remark)
      console.log('编码顺序: [studioAddress, amount, remark]')

      encodedData = abiCoder.encode(
        ['address', 'uint256', 'string'],
        [studioAddress, amountWei, remark]
      )

      console.log('编码后的数据 (前100字符):', encodedData.substring(0, 100) + '...')
      console.log('====================================================')
    } else {
      throw new Error(`Unknown abiKey: ${abiKey}`)
    }

    // 调用挖矿合约
    const contract = new ethers.Contract(miningContract.address, miningContract.abi, signer)

    console.log('==================== 调用合约 ====================')
    console.log('合约地址:', miningContract.address)
    console.log('调用方法: recharge')
    console.log('参数1 - abiKey:', abiKey)
    console.log('参数2 - encodedData (前100字符):', encodedData.substring(0, 100) + '...')
    console.log('====================================================')

    const tx = await contract.recharge(abiKey, encodedData, { gasLimit: 1000000 })

    console.log('==================== 交易已发送 ====================')
    console.log('交易哈希:', tx.hash)
    console.log('====================================================')

    if (tx.hash) {
      showLoadingToast({
        message: '链上确认中...',
        duration: 0
      })
    }

    await tx.wait()

    console.log('==================== 交易已确认 ====================')
    console.log('交易成功！')
    console.log('====================================================')

    closeToast()
    showToast('支付成功')
    return tx
  } catch (error) {
    console.error('==================== 支付失败 ====================')
    console.error('错误类型:', error.code)
    console.error('错误信息:', error.message)
    console.error('完整错误:', error)
    console.error('====================================================')

    closeToast()
    showToast('支付失败')
    throw error
  }
}

// 监听地址变更
export const onAccountChange = (callback) => {
  if (!isWalletInstalled()) {
    showToast('请安装钱包（如 MetaMask）')
    return
  }
  window.ethereum.on('accountsChanged', (accounts) => {
    callback(accounts?.[0] || '')
  })
}

// 监听链变更
export const onChainChange = (callback) => {
  if (!isWalletInstalled()) {
    showToast('请安装钱包（如 MetaMask）')
    return
  }
  window.ethereum.on('chainChanged', (chainId) => {
    const numericChainId = parseInt(chainId)
    console.log(numericChainId)
    callback(numericChainId)
  })
}

// LON映射合约相关方法
/**
 * 获取旧LON代币地址
 */
export const getOldLonToken = async () => {
  await ensureReady()
  const mappingContract = config.mapping
  if (!mappingContract) {
    throw new Error('Mapping contract not configured')
  }
  const contract = new ethers.Contract(mappingContract.address, mappingContract.abi, signer)
  return await contract.oldLonToken()
}

/**
 * 获取新LON代币地址
 */
export const getNewLonToken = async () => {
  await ensureReady()
  const mappingContract = config.mapping
  if (!mappingContract) {
    throw new Error('Mapping contract not configured')
  }
  const contract = new ethers.Contract(mappingContract.address, mappingContract.abi, signer)
  return await contract.newLonToken()
}

/**
 * 检查兑换是否开启
 */
export const getExchangeEnabled = async () => {
  await ensureReady()
  const mappingContract = config.mapping
  if (!mappingContract) {
    throw new Error('Mapping contract not configured')
  }
  const contract = new ethers.Contract(mappingContract.address, mappingContract.abi, signer)
  return await contract.exchangeEnabled()
}

/**
 * LON映射 - 将旧LON兑换为新LON
 * @param {string} amount - 兑换数量
 */
export const exchangeLon = async (amount) => {
  await ensureReady()
  const mappingContract = config.mapping
  if (!mappingContract) {
    throw new Error('Mapping contract not configured')
  }

  // 1. 获取旧LON代币地址
  showLoadingToast({
    message: '检查配置...',
    duration: 0
  })

  const oldLonAddress = await getOldLonToken()
  console.log('旧LON地址:', oldLonAddress)

  // 2. 检查兑换是否开启
  const exchangeEnabled = await getExchangeEnabled()
  if (!exchangeEnabled) {
    closeToast()
    showToast('兑换功能暂未开启')
    throw new Error('Exchange not enabled')
  }

  const amountWei = ethers.parseUnits(amount.toString(), 18)

  // 3. 检查旧LON余额
  showLoadingToast({
    message: '检查余额...',
    duration: 0
  })

  const balance = await getTokenBalance(oldLonAddress)
  if (balance < amountWei) {
    closeToast()
    showToast('旧LON余额不足')
    throw new Error('Insufficient balance')
  }

  // 4. 检查旧LON授权给兑换合约
  showLoadingToast({
    message: '检查授权...',
    duration: 0
  })

  const allowance = await getTokenAllowance(oldLonAddress, mappingContract.address)
  console.log('==================== 授权信息 ====================')
  console.log('旧LON地址:', oldLonAddress)
  console.log('兑换合约地址:', mappingContract.address)
  console.log('当前授权额度:', ethers.formatUnits(allowance, 18))
  console.log('需要兑换数量:', ethers.formatUnits(amountWei, 18))
  console.log('是否需要授权:', allowance < amountWei)
  console.log('================================================')

  // 如果授权额度小于兑换数量，需要重新授权
  if (allowance < amountWei) {
    try {
      showLoadingToast({
        message: '请在钱包中确认授权旧LON...',
        duration: 0
      })

      // 授权最大额度给兑换合约，手动设置gas limit
      console.log('开始授权交易...')
      let approveTx = await approveToken(oldLonAddress, mappingContract.address)

      console.log('授权交易已发送，哈希:', approveTx.hash)

      if (approveTx.hash) {
        showLoadingToast({
          message: '授权交易已提交，等待确认...',
          duration: 0
        })
      }

      // 等待授权交易确认
      const receipt = await approveTx.wait()
      console.log('授权交易已确认，区块:', receipt.blockNumber)

      showLoadingToast({
        message: '授权成功！',
        duration: 500
      })
    } catch (error) {
      closeToast()
      console.error('==================== 授权失败 ====================')
      console.error('错误类型:', error.code)
      console.error('错误信息:', error.message)
      console.error('完整错误:', error)
      console.error('================================================')

      // 根据不同的错误类型给出不同的提示
      if (error.code === 'ACTION_REJECTED' || error.code === 4001) {
        showToast('用户取消了授权')
      } else if (error.message.includes('insufficient funds')) {
        showToast('钱包余额不足，无法支付gas费用')
      } else if (error.code === 'UNKNOWN_ERROR' || error.message.includes('403')) {
        showToast('授权失败，请检查网络连接或稍后重试')
      } else {
        showToast('授权失败: ' + (error.reason || error.message || '未知错误'))
      }
      throw error
    }
  } else {
    console.log('授权额度充足，无需重新授权')
  }

  try {
    showLoadingToast({
      message: '请在钱包中确认兑换交易...',
      duration: 0
    })

    // 5. 调用映射合约的exchange方法
    const contract = new ethers.Contract(mappingContract.address, mappingContract.abi, signer)

    console.log('==================== 兑换信息 ====================')
    console.log('兑换合约地址:', mappingContract.address)
    console.log('兑换数量:', ethers.formatUnits(amountWei, 18), 'LON')
    console.log('================================================')

    // 手动设置 gas limit 避免估算失败
    const tx = await contract.exchange(amountWei, { gasLimit: 300000 })

    console.log('兑换交易已发送，哈希:', tx.hash)

    if (tx.hash) {
      showLoadingToast({
        message: '兑换交易已提交，等待确认...',
        duration: 0
      })
    }

    const receipt = await tx.wait()
    console.log('兑换交易已确认，区块:', receipt.blockNumber)

    closeToast()
    showToast('兑换成功！')
    return tx
  } catch (error) {
    closeToast()
    console.error('==================== 兑换失败 ====================')
    console.error('错误类型:', error.code)
    console.error('错误信息:', error.message)
    console.error('完整错误:', error)
    console.error('================================================')

    // 根据不同的错误类型给出不同的提示
    if (error.code === 'ACTION_REJECTED' || error.code === 4001) {
      showToast('用户取消了兑换')
    } else if (error.message.includes('insufficient funds')) {
      showToast('钱包余额不足，无法支付gas费用')
    } else if (error.code === 'UNKNOWN_ERROR' || error.message.includes('403')) {
      showToast('兑换失败，请检查网络连接或稍后重试')
    } else if (
      error.message.includes('Exchange not enabled') ||
      error.reason?.includes('Exchange not enabled')
    ) {
      showToast('兑换功能暂未开启')
    } else {
      showToast('兑换失败: ' + (error.reason || error.message || '未知错误'))
    }
    throw error
  }
}

export default {
  get provider() {
    return provider
  },
  get signer() {
    return signer
  },
  onAccountChange,
  onChainChange,
  signMessage,
  getMainAllowance,
  pay,
  approve,
  getMainBalance,
  getTokenBalance,
  getTokenAllowance,
  approveToken,
  miningPay,
  transferBNB,
  ensureReady,
  // LON映射相关
  getOldLonToken,
  getNewLonToken,
  getExchangeEnabled,
  exchangeLon
}
